import { render, staticRenderFns } from "./WavesPage.vue?vue&type=template&id=7de47438&"
import script from "./WavesPage.vue?vue&type=script&lang=js&"
export * from "./WavesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports